import React from 'react'
import styles from './CompanyLogoStrip.module.css'
import { CLIENT_LOGOS } from './clientLogos'

// DEV-3366のCパターンで導入し、DEV-3419で恒久化した企業ロゴ帯。SlimFirstViewの直下に常時表示する。
// DEV-3102(FirstViewC)で本番稼働していた実装の復刻。AB判定は持たない。
// ロゴ10社をCSSアニメーションで無限ループさせる
// （3周分を並べて -100% までスライドさせ繰り返す）。
export const CompanyLogoStrip = () => {
    return (
        <div>
            <aside className={styles.bannerMessage}>
                <p>例えばこんな企業の求人がございます</p>
            </aside>
            <div className={styles.clientSlider}>
                {Array.from({ length: 3 }).map((_, slideIndex) => (
                    <ul key={`client-slide-${slideIndex}`} className={styles.slideShow}>
                        {CLIENT_LOGOS.map((client) => (
                            <li key={`${client.id}-${slideIndex}`} className={styles.slide}>
                                <img
                                    src={client.src}
                                    alt={client.alt}
                                    className={styles.clientLogo}
                                />
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
        </div>
    )
}

export default CompanyLogoStrip
